"use strict";
exports.__esModule = true;
exports.SubscriptionNotificationType = exports.SubscriptionType = void 0;
var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType[SubscriptionType["Email"] = 0] = "Email";
})(SubscriptionType = exports.SubscriptionType || (exports.SubscriptionType = {}));
var SubscriptionNotificationType;
(function (SubscriptionNotificationType) {
    SubscriptionNotificationType[SubscriptionNotificationType["InvalidInventory"] = 0] = "InvalidInventory";
    SubscriptionNotificationType[SubscriptionNotificationType["EtlReport"] = 1] = "EtlReport";
    SubscriptionNotificationType[SubscriptionNotificationType["WebhookFailures"] = 2] = "WebhookFailures";
    SubscriptionNotificationType[SubscriptionNotificationType["MenuIssue"] = 3] = "MenuIssue";
    SubscriptionNotificationType[SubscriptionNotificationType["IntegrationPollingError"] = 4] = "IntegrationPollingError";
})(SubscriptionNotificationType = exports.SubscriptionNotificationType || (exports.SubscriptionNotificationType = {}));
//# sourceMappingURL=notification_subscription.js.map